import React from 'react';
import InfoIcon from '@material-ui/icons/Info';
import { TooltipProps } from '@material-ui/core/Tooltip';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import Tooltip from './Tooltip';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      lineHeight: 0, // lineheight is increasing height
      borderRadius: '50%',
      display: 'inline-block',
    },
    paper: {
      padding: theme.spacing(1, 2),
      margin: theme.spacing(0.75),
      minWidth: '10rem',
      maxWidth: '40rem',
    },
    hoverIcon: {
      display: 'inline-block',
      color: theme.palette.grey[400],
      '&:hover': {
        color: theme.palette.grey[700],
      },
      [theme.breakpoints.down('xs')]: {
        width: '0.8em',
        height: '0.8em',
      },
    },
    icon: {
      transform: `scale(0.7) translate(${theme.spacing(0.5, 1)})`,
    },
    heading: {
      transform: `scale(0.85) translate(4px, 4px)`,
      display: 'inline-block',
    },
    inline: {
      display: 'inline-block',
      verticalAlign: 'middle',
      transform: `translate(4px, 0px)`,
      '& svg': {
        width: '0.85em',
        height: '0.85em',
      },
    },
    table: {
      position: 'absolute',
      right: '16px',
      top: '8px',
      '& svg': {
        width: '0.85em',
        height: '0.85em',
      },
    },
    button: {
      display: 'inline-block',
      verticalAlign: 'middle',
      transform: `translate(4px, -3px)`,
      '& .MuiSvgIcon-root': {
        width: '0.75em',
        height: '0.75em',
      },
    },
    subtitle: {
      transform: `translate(4px, -4px)`,
      verticalAlign: 'top',
    },
    black: {
      background: 'transparent',
      '& svg': { color: '#333 !important' },
      '&:hover svg': { color: '#000 !important' },
    },
    help: {
      borderRadius: '50%',
      position: `absolute`,
      top: 1,
      right: 1,
      transform: 'translate(50%, -50%)',
    },
  }),
);

interface Props {
  heading?: boolean;
  subtitle?: boolean;
  inline?: boolean;
  button?: boolean;
  black?: boolean;
  help?: boolean;
  table?: boolean;
  className?: string;
  iconProps?: SvgIconProps;
  content: React.ReactElement | string;
  tooltipProps?: Partial<TooltipProps>;
}

const Info: React.FC<Props> = ({
  className,
  content,
  heading,
  subtitle,
  inline,
  button,
  black,
  help,
  table,
  iconProps,
  tooltipProps,
}) => {
  const classes = useStyles();

  return (
    <span
      className={`${classes.root} ${className ? className : ''} ${heading ? classes.heading : ''}${
        inline ? ' ' + classes.inline : ''
      }${button ? ' ' + classes.button : ''}${black ? ' ' + classes.black : ''}${table ? ' ' + classes.table : ''}${
        help ? ' ' + classes.help : ''
      }${subtitle ? ' ' + classes.subtitle : ''}`}
    >
      <Tooltip title={content || ''} {...tooltipProps}>
        <InfoIcon {...iconProps} className={classes.hoverIcon} />
      </Tooltip>
    </span>
  );
};

export default React.memo(Info);
